export default __webpack_public_path__ + "static/media/Four-in-one-sensor-active_v1.aff4ab60.svg";